import React from 'react';
import { useTranslation } from 'react-i18next';
import { inject, observer } from 'mobx-react';
import { PatientStore } from '../../../global/Store/PatientStore';
import { useGetResourceUrl } from '../../../global/entities/TherapeuticIndication/queries/useGetResourceUrl';
import { Loading } from '../../../global/component/organism/Loading/Loading';

interface IResourcesPageProps {
  patientStore?: PatientStore;
}

const ResourcesPage: React.FC<IResourcesPageProps> = inject('patientStore')(
  observer(({ patientStore }) => {
    const { t } = useTranslation();
    const therapeuticIndicationId = patientStore?.therapeuticIndicationId
      ? Number(patientStore.therapeuticIndicationId)
      : undefined;

    const { data: resourceUrl, isLoading } = useGetResourceUrl(therapeuticIndicationId);

    if (isLoading)
      return <Loading visible={true} loadingMessage="" />;

    if (!resourceUrl) {
      return (
        <div style={{
          padding: '20px',
          textAlign: 'center',
          color: '#666',
          fontSize: '16px'
        }}>
          <p>{t('therapeuticIndicationResources.noResources')}</p>
        </div>
      );
    }

    return (
      <div id='page-container-local' style={{ height: '100%', width: '100%' }}>
        <iframe
          src={resourceUrl}
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            overflow: 'auto'
          }}
          title="External Resource Content"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-downloads"
          loading="lazy"
        />
      </div>
    );
  })
);

export default ResourcesPage;
